{
  /* TODO: Will be migrated to viome_base once the mobile team completes it. */
}

export const JourneyEducationTypes = {
  NUTRITION_FOOTER: 'nutrition_footer',
  HEALTH_HOME: 'health_home',
  L2_DETAIL: 'l2_detail',
  L2_DETAIL_IMMUNE: 'l2_detail_immune',
  L2_DETAIL_MOOD: 'l2_detail_mood',
  L2_DETAIL_ORAL: 'l2_detail_oral',
  L2_DETAIL_ENERGY: 'l2_detail_energy',
  L2_DETAIL_HEART: 'l2_detail_heart',
  L2_DETAIL_GUT: 'l2_detail_gut',
  BIOAGE_DETAIL: 'bioage_detail',
  INFLAMMAGING_DETAIL: 'inflammaging_detail',
  GUT_MICROBIOME_DETAIL: 'gut_microbiome_detail',
  ORAL_MICROBIOME_DETAIL: 'oral_microbiome_detail',
  HOME_PRE_RNR_TESTING_RESOURCE: 'home_pre_rnr_testing_resource',
  HOME_PRE_RNR: 'home_pre_rnr',
  HOME_POST_RNR: 'home_post_rnr',
  HOME_POST_RNR_RETEST_TESTING_RESOURCE:
    'home_post_rnr_retest_testing_resource',
  HOME_POST_RNR_RETEST: 'home_post_rnr_retest',
  GUT_MICROBIOME: 'gut_microbiome',
  ORAL_MICROBIOME: 'oral_microbiome',
};
